@if (headerService) {
  <div class="sidebar-account-menu">
    @if (currentUser) {
      <div class="menu-user"
           [class.menu-user--expanded]="isExpanded"
           role="button"
           tabindex="0"
           [attr.aria-expanded]="isExpanded"
           aria-label="Account menu"
           (click)="toggleExpanded()"
           (keydown.enter)="toggleExpanded()"
           (keydown.space)="$event.preventDefault(); toggleExpanded()">
        <div class="menu-user__avatar">
          <ngf-avatar-image [userId]="currentUser.platformId" size="s"></ngf-avatar-image>
        </div>
        <div class="menu-user__info">
          <div class="menu-user__name">{{ currentUser.firstName }} {{ currentUser.lastName }}</div>
          <div class="menu-user__id">
            ID: {{ currentUser.platformId }}
            <button
              type="button"
              class="menu-user__copy-button"
              [title]="isTextCopied ? 'Copied!' : 'Copy ID'"
              [attr.aria-label]="isTextCopied ? 'Copied!' : 'Copy ID'"
              (click)="$event.stopPropagation(); onCopyUserId()">
              @if (!isTextCopied) {
                <img src="assets/images/icons/copy-01.svg" alt="" aria-hidden="true" width="16" height="16" />
              } @else {
                <svg class="copy-check-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <path d="M2 8.5L6 12.5L14 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              }
            </button>
            @if (isTTL) {
              <ngf-pill class="menu-user__badge">TTL</ngf-pill>
            }
            @if (isLite) {
              <ngf-pill class="menu-user__badge">LITE</ngf-pill>
            }
          </div>
        </div>
        <svg class="menu-user__chevron" [class.menu-user__chevron--expanded]="isExpanded"
             width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    }

    @if (isExpanded) {
      @if (accountUrls) {
        <a class="menu-btn menu-btn--first" [href]="accountUrls.accountSettings" (click)="onMenuLinkClick()">
          <span class="menu-btn__content">
            <span class="menu-btn__icon menu-btn__icon--user-edit"></span>
            Account Settings
          </span>
        </a>

        @if (accountUrls.accountSecurity) {
          <a class="menu-btn" [href]="accountUrls.accountSecurity" (click)="onMenuLinkClick()">
            <span class="menu-btn__content">
              <span class="menu-btn__icon menu-btn__icon--shield-tick"></span>
              Access & Security
            </span>
          </a>
        }

        <a class="menu-btn" [href]="accountUrls.accountAdvanced" (click)="onMenuLinkClick()">
          <span class="menu-btn__content">
            <span class="menu-btn__icon menu-btn__icon--settings"></span>
            Advanced Settings
          </span>
        </a>
      }

      <a class="menu-btn" href="https://support.utest.com/" target="_blank" rel="noopener" (click)="onMenuLinkClick()">
        <span class="menu-btn__content">
          <span class="menu-btn__icon menu-btn__icon--book-open"></span>
          Knowledge Base
          <mat-icon aria-hidden="true">open_in_new</mat-icon>
        </span>
      </a>

      <button type="button" class="menu-btn menu-btn--with-divider menu-btn--last" (click)="onSignOut()">
        <span class="menu-btn__content">
          <span class="menu-btn__icon menu-btn__icon--log-out"></span>
          Sign out
        </span>
      </button>
    }
  </div>
}
